"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var _b = _a.height, height = _b === void 0 ? 20 : _b, _c = _a.width, width = _c === void 0 ? 20 : _c;
    return (react_1.default.createElement("i", null,
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.1", x: "0px", y: "0px", width: width, height: height, viewBox: "0 0 357 357" },
            react_1.default.createElement("g", { id: "add" },
                react_1.default.createElement("path", { d: "M357,204H204v153h-51V204H0v-51h153V0h51v153h153V204z" })))));
});
